/**
 * Centralized SVG gradient definitions for the entire application.
 * This component should be included once at the app root level to make
 * all gradient definitions available throughout the component tree.
 */
export const GradientDefinitions = () => {
  return (
    <svg width="0" height="0" style={{ position: 'absolute' }}>
      <defs>
        {/* Main AI gradient for chevron/arrow icons */}
        <linearGradient
          id="aiGradientChevron"
          x1="0%"
          y1="0%"
          x2="100%"
          y2="100%"
        >
          <stop offset="0%" stopColor="#7a93c0" />
          <stop offset="50%" stopColor="#c790ac" />
          <stop offset="100%" stopColor="#ecd095" />
        </linearGradient>

        {/* AI gradient for fire icons */}
        <linearGradient id="aiGradientFire" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#7a93c0" />
          <stop offset="50%" stopColor="#c790ac" />
          <stop offset="100%" stopColor="#ecd095" />
        </linearGradient>

        {/* Brighter variant for interactive elements */}
        <linearGradient
          id="aiGradientBright"
          x1="0%"
          y1="0%"
          x2="100%"
          y2="100%"
        >
          <stop offset="0%" stopColor="#8ba3d0" />
          <stop offset="50%" stopColor="#d7a0bc" />
          <stop offset="100%" stopColor="#f0d7a5" />
        </linearGradient>

        {/* Deeper variant for emphasis */}
        <linearGradient id="aiGradientDeep" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#6a83b0" />
          <stop offset="50%" stopColor="#b7809c" />
          <stop offset="100%" stopColor="#dcc085" />
        </linearGradient>
      </defs>
    </svg>
  )
}
